var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSber = function SvgSber(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2112 4.66309C25.7737 5.4001 26.2499 6.2008 26.6301 7.04911L15.844 15.1072L11.3362 12.2434V8.79811L15.844 11.6619L25.2112 4.66309Z",
    fill: "#21A038"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73558 11.9999C6.73558 11.8453 6.7393 11.6917 6.74674 11.539L4.01488 11.4033C4.00558 11.6012 4 11.801 4 12.0026C3.99884 13.5781 4.30462 15.1383 4.89979 16.5937C5.49497 18.0491 6.36782 19.3711 7.46829 20.4838L9.40607 18.5209C8.55897 17.6659 7.88696 16.6496 7.42867 15.5305C6.97037 14.4114 6.73483 13.2115 6.73558 11.9999Z",
    fill: "url(#paint0_linear_1308_56381)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8415 2.77149C15.9939 2.77149 16.1455 2.77715 16.2961 2.78469L16.4328 0.0151201C16.237 0.00569664 16.0398 0.000985463 15.8415 0.000985463C14.2862 -0.000936702 12.7459 0.308506 11.309 0.911543C9.87207 1.51458 8.56685 2.39934 7.46826 3.51502L9.40604 5.47887C10.2498 4.62009 11.2527 3.93879 12.3571 3.47416C13.4615 3.00953 14.6456 2.77073 15.8415 2.77149Z",
    fill: "url(#paint1_linear_1308_56381)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8415 21.2284C15.689 21.2284 15.5374 21.2284 15.3859 21.2161L15.2492 23.9847C15.4457 23.9948 15.6432 23.9999 15.8415 23.9999C17.3961 24.0015 18.9357 23.6918 20.3718 23.0886C21.808 22.4854 23.1123 21.6005 24.2101 20.4849L22.276 18.522C21.4321 19.3803 20.4293 20.0612 19.3251 20.5257C18.2209 20.9901 17.037 21.229 15.8415 21.2284Z",
    fill: "url(#paint2_linear_1308_56381)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9742 4.38195L23.2765 2.66216C21.1722 0.935262 18.5455 -0.00479367 15.8378 1.83829e-05V2.77147C17.6713 2.76917 19.4623 3.33073 20.9742 4.38195Z",
    fill: "url(#paint3_linear_1308_56381)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6821 12.0001C27.6836 11.2791 27.6214 10.5594 27.4961 9.84961L24.9475 11.7532C24.9475 11.8352 24.9475 11.9171 24.9475 12.0001C24.9482 13.2895 24.6814 14.5646 24.1647 15.7429C23.648 16.9211 22.8927 17.9761 21.9478 18.8396L23.7861 20.8987C25.0145 19.7748 25.9961 18.4019 26.6672 16.869C27.3385 15.336 27.6842 13.6772 27.6821 12.0001Z",
    fill: "#21A038"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8416 21.2285C14.5692 21.2289 13.3109 20.9586 12.1481 20.4349C10.9854 19.9112 9.94419 19.1459 9.09185 18.1885L7.0611 20.0506C8.16989 21.2956 9.52452 22.2906 11.0372 22.971C12.5498 23.6513 14.1866 24.0019 15.8416 23.9999V21.2285Z",
    fill: "url(#paint4_linear_1308_56381)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73524 5.16035L7.89789 3.10132C6.66917 4.22495 5.68722 5.59778 5.01572 7.13077C4.34422 8.66374 3.99817 10.3227 4.00001 11.9999H6.73559C6.73502 10.7106 7.00176 9.43542 7.5185 8.25718C8.03524 7.07898 8.79047 6.0239 9.73524 5.16035Z",
    fill: "url(#paint5_linear_1308_56381)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1308_56381",
    x1: 8.02155,
    y1: 20.138,
    x2: 4.96094,
    y2: 11.4079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F1E813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#C9DA26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A2CC39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1308_56381",
    x1: 8.24932,
    y1: 4.00504,
    x2: 15.9733,
    y2: 1.10064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0FA7DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0098F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0290EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1308_56381",
    x1: 15.0689,
    y1: 22.3272,
    x2: 23.7851,
    y2: 20.3842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A2CC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#86C239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#219F38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1308_56381",
    x1: 15.2688,
    y1: 0.928233,
    x2: 22.7283,
    y2: 3.19964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0290EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0C89CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1308_56381",
    x1: 7.74731,
    y1: 19.7132,
    x2: 15.8744,
    y2: 22.7102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F1E813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EAE616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D8DF1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BAD52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#A2CC39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1308_56381",
    x1: 5.01911,
    y1: 12.3354,
    x2: 8.34725,
    y2: 3.79266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#A2CC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#81C45E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0FA7DF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSber);
export default ForwardRef;